import styled, { css } from 'styled-components';

export const Form = styled.form`
    ${({ modal }) => modal && css`
        margin-bottom: 45px;
    `}
`;

export const Wrap = styled.div`
    margin-bottom: 30px;
`;
